import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import Localizer from "@Scripts/Common/Localizer";
import GoogleMapsHelper from "@Scripts/Infrastructure/GoogleMapsHelper";

@Component({ name: "WhereToBuyMap" })
export default class WhereToBuyMap extends Vue {
    public localizer: any = Localizer;
    public googleMapsHelper: any = GoogleMapsHelper;
    public isLoading: boolean = false;
    public showFilters: boolean = false;
    public showMap: boolean = false;
    public isUpgrade: boolean = false;
    public isCreated: boolean = true;

    public geoMarkerTypes: any[] = null;
    public geoMarkerMarkets: any[] = null;
    public notFoundUrl: string = null;
    public infoRequestUrl: string = null;

    public market: string = null;
    public marketType: string = null;
    public type: string = null;

    public geoMarkerFilter: any = {
        topRightLatitude: null,
        topRightLongitude: null,
        bottomLeftLatitude: null,
        bottomLeftLongitude: null,
        market: "Car",
        types: []
    };

    public geoMarkers: any[] = [];
    public mapErrors: any[] = [];

    public suggestionIndex: number = -1;
    public suggestions: any[] = [];
    public searchtext: string = null;
    public debounceTimeOut: any = null;

    @Prop() readonly region: string;
    @Prop() readonly language: string;
    @Prop() readonly isBremboExpert: boolean;

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        const self = this;
        this.isLoading = true;

        await Promise.all([this.googleMapsHelper.loadMap(), this.getFilterData()]);

        if (this.$route.query.market) {
            this.market = this.$route.query.market.toString();
        }

        if (this.$route.query.marketType) {
            this.marketType = this.$route.query.marketType.toString();
        }

        if (this.$route.query.type) {
            this.type = this.$route.query.type.toString();
        }

        if (this.type) {
            this.geoMarkerFilter.types = [this.type];
        }

        if (this.market && (this.market.toLowerCase() === "car" || this.market.toLowerCase() === "bike")) {
            this.geoMarkerFilter.market = this.market[0].toUpperCase() + this.market.slice(1).toLowerCase();
        }

        if (this.marketType) {
            if (this.marketType.toLowerCase() === "aftermarket") {
                if (this.geoMarkerFilter.market.toLowerCase() === "car") {
                    this.geoMarkerFilter.types = ["Dealer", "Brembo Expert", "Garage"];
                }

                if (this.geoMarkerFilter.market.toLowerCase() === "bike") {
                    this.geoMarkerFilter.types = ["Official Partner", "Dealer", "Expert Dealer"];
                }
            } else if (this.marketType.toLowerCase() === "upgrade") {
                if (this.geoMarkerFilter.market.toLowerCase() === "car") {
                    this.geoMarkerFilter.types = ["Upgrade Installer", "Upgrade Dealer"];
                }

                if (this.geoMarkerFilter.market.toLowerCase() === "bike") {
                    this.geoMarkerFilter.types = ["Racing Installer", "Upgrade Installer", "Upgrade Dealer"];
                }
            } else {
                this.$router.push({ name: "WhereToBuyMap", params: { region: this.region, language: this.language }, query: { type: this.type } });
            }
        }

        this.googleMapsHelper.mapInstance.addListener("tilesloaded", async () => {
            do {
                await self.getGeoMarkers();
            } while (self.isCreated && self.geoMarkers.length === 0);
        });

        this.isLoading = false;
    }

    public mounted() {
        const outsideClickListener = event => {
            if (!document.getElementById("AutocompleteLocation").contains(event.target)) {
                this.searchtext = null;
            }
        }

        document.addEventListener("click", outsideClickListener);
    }

    public setMarket(market: string) {
        this.geoMarkerFilter.market = market;
        this.geoMarkerFilter.types = [];
        this.getGeoMarkers();
    }

    public setType(type: string) {
        if (this.geoMarkerFilter.types.some(x => x.toLowerCase() === type.toLowerCase())) {
            const index = this.geoMarkerFilter.types.indexOf(type);
            if (index > -1) {
                this.geoMarkerFilter.types.splice(index, 1);
            } else {
                const index = this.geoMarkerFilter.types.indexOf(type.toLowerCase());
                if (index > -1) {
                    this.geoMarkerFilter.types.splice(index, 1);
                }
            }
        } else {
            this.geoMarkerFilter.types.push(type);
            GTagHelper.sendCustomEvent("click", { wheretobuy: "filter_" + type });
        }

        if (this.geoMarkerFilter.market.toLowerCase() === "car") {
            this.isUpgrade = this.geoMarkerFilter.types.some(x => ["Upgrade Installer", "Upgrade Dealer"].includes(x));
            if (this.geoMarkerFilter.types.some(x => ["Dealer", "Brembo Expert", "Garage"].includes(x))) {
                this.isUpgrade = false;
            }
        }

        if (this.geoMarkerFilter.market.toLowerCase() === "bike") {
            this.isUpgrade = this.geoMarkerFilter.types.some(x => ["Racing Installer", "Upgrade Installer", "Upgrade Dealer"].includes(x));
            if (this.geoMarkerFilter.types.some(x => ["Official Partner", "Dealer", "Expert Dealer"].includes(x))) {
                this.isUpgrade = false;
            }
        }

        this.getGeoMarkers();
    }

    public async getFilterData() {
        let response = (await Axios.post(this.routes.WhereToBuy_GetFilterData)).data;
        if (response) {
            this.geoMarkerTypes = response.geoMarkerTypes;
            this.geoMarkerMarkets = response.geoMarkerMarkets;
            this.notFoundUrl = response.notFoundUrl;
            this.infoRequestUrl = response.infoRequestUrl;
        } else {
            this.geoMarkerTypes = null;
            this.geoMarkerMarkets = null;
            this.notFoundUrl = null;
            this.infoRequestUrl = null;
        }
    }

    public async getGeoMarkers() {
        let mapBounds = this.googleMapsHelper.getBounds();

        let nePoint = mapBounds.getNorthEast();
        let swPoint = mapBounds.getSouthWest();

        this.geoMarkerFilter.topRightLatitude = nePoint.lat();
        this.geoMarkerFilter.topRightLongitude = nePoint.lng();
        this.geoMarkerFilter.bottomLeftLatitude = swPoint.lat();
        this.geoMarkerFilter.bottomLeftLongitude = swPoint.lng();

        let response = (await Axios.post(this.routes.WhereToBuy_GetGeoMarkers, this.geoMarkerFilter)).data;
        if (this.isCreated) {
            if (response && response.length !== 0) {
                this.isCreated = false;
            } else if (this.googleMapsHelper.mapInstance.zoom !== this.googleMapsHelper.mapInstance.minZoom) {
                this.googleMapsHelper.mapInstance.setZoom(this.googleMapsHelper.mapInstance.zoom - 1);
            } else if (this.googleMapsHelper.mapInstance.zoom === this.googleMapsHelper.mapInstance.minZoom) {
                this.isCreated = false;
            }
        }

        this.googleMapsHelper.removeMarkers();
        this.geoMarkers = response;

        for (const item of this.geoMarkers) {
            let description = "<div class=\"market-info\"><div class=\"data\"><div class=\"type\" data-type=\"" + item.marketType.toLowerCase() + "\">" + item.type + "</div><div class=\"name\">" + item.company + "</div><div class=\"address\">" + item.address + " " + item.location + " " + item.postCode + "</div><div class=\"contact\">";

            if (item.phone) {
                description += "<a href=\"tel:" + item.phone + "\" class=\"item\"><span class=\"icon fastic-phone\"></span><span class=\"label\">" + item.phone + "</span></a>";
            }
            if (item.websiteUrl) {
                description += "<a href=\"" + item.websiteUrl + "\" target=\"_blank\" rel=\"noreferrer\" class=\"item\"><span class=\"icon fastic-globe\"></span><span class=\"label\">" + this.localizer.get("WhereToBuy.Common.WebSite") + "</span></a>";
            }
            if (item.email) {
                description += "<a href=\"mailto:" + item.email + "\" class=\"item\"><span class=\"icon fastic-mail\"></span><span class=\"label\">" + this.localizer.get("WhereToBuy.Common.Email") + "</span></a>";
            }

            description += "<a href=\"https://www.google.com/maps/place/?q=place_id:" + item.googlePlaceId + "\" target=\"_blank\" rel=\"noreferrer\" class=\"item\"><span class=\"icon fastic-direction\"></span><span class=\"label\">" + this.localizer.get("WhereToBuy.Common.Direction") + "</span></a></div></div>";
            description += "</div>";

            this.googleMapsHelper.addMarker(item.idMaster, item.latitude, item.longitude, item.type, item.company, description);
        }

        this.googleMapsHelper.setMarkerCluster();
    }

    public onSearchtextChanged() {
        this.debounceSearchText(500);
    }

    public async centerToUser() {
        const self = this;

        navigator.geolocation.getCurrentPosition(function (result) {
            self.googleMapsHelper.setActiveInfoWindowId(null);
            self.googleMapsHelper.setCenter(result.coords.latitude, result.coords.longitude);
            self.googleMapsHelper.mapInstance.setZoom(15);
        }, function () { }, {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
        });
    }

    public centerMarker(geoMarker: any) {
        this.googleMapsHelper.setActiveInfoWindowId(geoMarker.idMaster);
        this.googleMapsHelper.setCenter(geoMarker.latitude, geoMarker.longitude);
        this.googleMapsHelper.mapInstance.setZoom(17);
        this.googleMapsHelper.clickMarker(geoMarker.idMaster);
        this.toggleMap();
    }

    public toggleFilters() {
        this.showFilters = !this.showFilters;
    }

    public toggleMap() {
        this.showMap = !this.showMap;
    }

    public async debounceSearchText(delay: number) {
        const self = this;
        clearTimeout(this.debounceTimeOut);
        this.debounceTimeOut = setTimeout(async function (context) {
            if (self.searchtext && self.searchtext.length >= 3) {
                await self.getSuggestions();
            } else {
                self.suggestions = [];
                self.suggestionIndex = -1;
            }
        }, delay, this);
    }

    public async getSuggestions() {
        const self = this;

        let autocompleteService = this.googleMapsHelper.getAutocompleteService();
        autocompleteService.getPlacePredictions({ input: this.searchtext, language: this.language, types: ["locality"] }, async function (suggestions) {
            let placeSuggestions: any[] = [];

            if (suggestions) {
                placeSuggestions = suggestions.map(x => ({
                    description: x.description,
                    address: x.description,
                    type: "Place"
                }));
            }

            const response = (await Axios.post(self.routes.WhereToBuy_GetSuggestionPlace, {
                searchtext: self.searchtext,
                market: self.geoMarkerFilter.market,
                types: self.geoMarkerFilter.types
            })).data;

            self.suggestions = [...placeSuggestions, ...response];
            self.suggestions = self.suggestions.map((obj, index) => ({ ...obj, index }));
        });
    }

    public async searchPlace() {
        if (this.searchtext?.length >= 3) {
            this.resetSuggestionValues();
            await this.getSuggestions();
        }
    }

    public resetSuggestionValues() {
        this.suggestionIndex = -1;
        this.suggestions = [];
    }

    public resetSearchtext() {
        this.searchtext = null;
        this.resetSuggestionValues();
    }

    public suggestionMoveDown() {
        if (this.suggestions.length !== 0 && this.suggestionIndex < this.suggestions.length - 1) {
            this.suggestionIndex++;
        }
    }

    public suggestionMoveUp() {
        if (this.suggestions.length !== 0 && this.suggestionIndex > 0) {
            this.suggestionIndex--;
        }
    }

    public async selectSuggestion(suggestion: any) {
        const self = this;
        this.mapErrors = [];

        if (suggestion.type === "Place") {
            this.googleMapsHelper.setActiveInfoWindowId(null);

            let geocoder = this.googleMapsHelper.getGeocoder();
            geocoder.geocode({ address: suggestion.address }, async function (data, status) {
                if (status === (<any>window).google.maps.GeocoderStatus.OK && data) {
                    let place = data[0];

                    if (place && !place.geometry) {
                        self.mapErrors.push(self.localizer.get("WhereToBuy.Common.AddressNotFound"));
                        setTimeout(function () { self.mapErrors = []; }, 3000);
                        return;
                    } else {
                        let location = place.geometry.location.toJSON();

                        self.googleMapsHelper.mapInstance.setZoom(14);
                        self.googleMapsHelper.setCenter(location.lat, location.lng);

                        self.searchtext = place.formatted_address;
                    }
                }
            });
        } else {
            this.setMarker(suggestion);
        }

        this.showMap = true;
        this.resetSuggestionValues();
    }

    public setPlace() {
        if (this.suggestionIndex !== -1) {
            const suggestion = this.suggestions[this.suggestionIndex];
            if (suggestion.type !== "Place") {
                this.setMarker(suggestion);
            } else {
                this.selectSuggestion(suggestion);
            }
        }
    }

    public setMarker(marker: any) {
        this.centerMarker(marker);
        this.searchtext = marker.company;
        this.resetSuggestionValues();
    }

    public website(company: string) {
        GTagHelper.sendCustomEvent("click", { wheretobuy: company + "_website" });
    }

    public email(company: string) {
        GTagHelper.sendCustomEvent("click", { wheretobuy: company + "_email" });
    }

    public phone(company: string) {
        GTagHelper.sendCustomEvent("click", { wheretobuy: company + "_phone" });
    }

    public direction(company: string) {
        GTagHelper.sendCustomEvent("click", { wheretobuy: company + "_direction" });
    }

    public claim(company: string) {
        GTagHelper.sendCustomEvent("click", { wheretobuy: company + "_claim" });
    }
};